export default __webpack_public_path__ + "static/media/Bloodseraph's Vambraces.46f17058.jpg";